"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { currentUser } from "@/lib/api";
import { homeFor } from "@/lib/auth";

/** Root: route the user to their role's home surface. */
export default function IndexPage() {
  const router = useRouter();

  useEffect(() => {
    const user = currentUser();
    router.replace(user ? (user.custom_role ? "/workspace" : homeFor(user.role)) : "/login");
  }, [router]);

  return (
    <p className="py-24 text-center text-sm text-muted-foreground">Loading…</p>
  );
}
